module.exports = __webpack_public_path__ + "static/media/20.3f0005df.jpg";